<script>
  import Block from './block.svelte'
  import Icon from './icon.svelte'
  import Row from './row.svelte'
  import Text from './text.svelte'
  import { createEventDispatcher } from 'svelte'

  export let icon = 'select-bold'
  export let iconColor = 'black'
  export let size = '1rem'
  export let checked = false
  export let disable = false
  export let border = 1
  export let borderRadius = undefined
  export let borderColor = undefined
  export let backgroundColor = undefined
  export let checkedBgColor = 'transparent'
  export let disableBgColor = 'lightgrey'
  export let space = '0.2rem'

  const dispatch = createEventDispatcher()

  function click() {
    if (disable) return
    checked = !checked
    dispatch('change', {checked: checked})
  }

</script>

<Block on:click={click} cursor=pointer>
  <Row>
    <Block
      {border} {borderRadius} {borderColor}
      width={size} height={size} boxSizing=content-box lineHeight={size}
      backgroundColor={disable?disableBgColor:(checked?checkedBgColor:backgroundColor)}
    >
      {#if checked}
      <Icon name={icon} color={iconColor} size={size}></Icon>
      {/if}
    </Block>
    {#if $$slots.default}
    <Block width={space}/>
    {/if}
    <slot></slot>
  </Row>
</Block>